export enum gaEventActions {
  /* Lime APP promotion  */
  limeAppBannerVisible = 'lime_app_promo_banner_visible',
  limeAppBannerClicked = 'lime_app_promo_banner_clicked',
  limeAppDownloadFromAppleClicked = 'lime_app_promo_apple_link_clicked',
  limeAppDownloadFromGoogleClicked = 'lime_app_promo_google_link_clicked'

  /* Do not forget to add the event in https://limehome.atlassian.net/wiki/spaces/EN/pages/500891700/Google+Analytics
   * Please leave this comment always at the end of the enum declaration
   * */
}
